import { createCommonjsModule, unwrapExports } from '../../../../_virtual/_commonjsHelpers.es.js';

var classCallCheck = createCommonjsModule(function (module) {
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
const _classCallCheck = unwrapExports(classCallCheck);

export { classCallCheck as __moduleExports, _classCallCheck as default };
